import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import styles from './Ejercicio10.module.scss';
import Swal from 'sweetalert2';
import { Row, Col, Form, FormGroup, FormControl } from 'react-bootstrap';

const camposHelios = [
  { id: 'heliotropo', etiqueta: 'Heliotropo' },
  { id: 'helioterapia', etiqueta: 'Helioterapia' }
];

const camposHemi = [
  { id: 'hemiciclo', etiqueta: 'Hemiciclo' },
  { id: 'hemisferio', etiqueta: 'Hemisferio' },
  { id: 'hemiplejia', etiqueta: 'Hemiplejia' }
];

const camposHeteros = [
  { id: 'heterogeneo', etiqueta: 'Heterogéneo' },
  { id: 'heterodoxo', etiqueta: 'Heterodoxo' },
  { id: 'heteromorfo', etiqueta: 'Heteromorfo' }
];

const camposHypos = [
  { id: 'hipoglicemia', etiqueta: 'Hipoglicemia' },
  { id: 'hipotesis', etiqueta: 'Hipótesis' },
  { id: 'hipotalamo', etiqueta: 'Hipotálamo' },
  { id: 'hipogeo', etiqueta: 'Hipogeo' }
];

const camposHipos = [
  { id: 'hipodromo', etiqueta: 'Hipódromo' },
  { id: 'hipica', etiqueta: 'Hípica' }
];

const camposHomoios = [
  { id: 'homologo', etiqueta: 'Homólogo' },
  { id: 'homosexual', etiqueta: 'Homosexual' },
  { id: 'homofono', etiqueta: 'Homófono' },
  { id: 'homogeneoHomoios', etiqueta: 'Homogéneo' }
];

const camposHiper = [
  { id: 'hipertrofia', etiqueta: 'Hipertrofia' },
  { id: 'hipermercado', etiqueta: 'Hipermercado' },
  { id: 'hipermetropia', etiqueta: 'Hipermetropía' }
];

const Ejercicio10 = ({ cerrarModal }) => {
  const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
  const [respuestas, setRespuestas] = useState({
    geopolitica: '',
    geografia: '',
    geometria: '',
    geologia: '',
    heterogeneo: '',
    heterodoxo: '',
    heteromorfo: '',
    hipoglicemia: '',
    hipotesis: '',
    hipotalamo: '',
    hipogeo: '',
    hipodromo: '',
    hipica: '',
    homologo: '',
    homosexual: '',
    homofono: '',
    homogeneo: '',
    homogeneoHomoios: '',
    hipertrofia: '',
    hipermercado: '',
    hipermetropia: '',
    heliotropo: '',
    helioterapia: '',
    hemiciclo: '',
    hemisferio: '',
    hemiplejia: ''
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setRespuestas(prev => ({ ...prev, [name]: value }));
  };

  const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

    const emptyFields = Object.entries(respuestas).filter(([key, value]) => !value.trim());
    if (emptyFields.length > 0) {
      console.log("Campos vacíos:", emptyFields);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Todos los campos deben estar llenos antes de enviar la evaluación.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    try {
      await addDoc(collection(db, "evaluaciones"), {
        userId: currentUser.uid,
        nombre: "Módulo 3 - Ejercicio de Comprensión",
        nivel: "Basico",
        modulo: "3",
        tipo: "Texto libre",
        createdAt: new Date(),
        respuestas
      });
      Swal.fire({
        title: '¡Evaluación Enviada!',
        text: 'Resultados enviados con éxito.',
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Excelente'
      }).then((result) => {
        if (result.isConfirmed) {
          cerrarModal(); // Cierra la modal al confirmar la alerta
        }
      });
    } catch (error) {
      console.error("Error al enviar las respuestas: ", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al enviar las respuestas.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });
    }
  };

  return (
    <div className={styles.container}>
      <h3>Nivel Básico</h3>
      <h3>Módulo 3 - Ejercicio 10</h3>
      <h5>Ejercicio de Comprensión</h5>

      <p><strong>Incremente su Vocabulario</strong></p>
      <Row>
      <Col md={6}>
      
        
      <Form className='border p-3'>
            {/* Contenido de la primera columna */}
            <FormGroup className="mb-3">
            <p><strong>Raíces Griegas </strong></p>
            {/* Ge, genos = tierra */}
              <p><strong>Raíz: Ge, genos = tierra</strong></p>
              <p>Apogeo: Punto en que la luna se encuentra a mayor distancia de la tierra. Apo, significa separación, contra, fuera de.</p>
  
    <FormGroup className="mb-3">
        <div className="text-muted small mb-1">Geopolitica</div>
        <FormControl
            type="text"
            name="geopolitica"
            value={respuestas.geopolitica}
            onChange={handleChange}
        />
    </FormGroup>
    <FormGroup className="mb-3">
        <div className="text-muted small mb-1">Geografía</div>
        <FormControl
            type="text"
            name="geografia"
            value={respuestas.geografia}
            onChange={handleChange}
        />
    </FormGroup>
    <FormGroup className="mb-3">
        <div className="text-muted small mb-1">Geometría</div>
        <FormControl
            type="text"
            name="geometria"
            value={respuestas.geometria}
            onChange={handleChange}
        />
    </FormGroup>
    <FormGroup className="mb-3">
        <div className="text-muted small mb-1">Geología</div>
        <FormControl
            type="text"
            name="geologia"
            value={respuestas.geologia}
            onChange={handleChange}
        />
    </FormGroup>
   
              </FormGroup>
                                          

               </Form>
                <br />
                <Form className='border p-3'>
                <FormGroup className="mb-3">
              {/* Raíz: genos, genea:*/}
              <p><strong>Raíz: genos, genea: linaje </strong>= origen, génesis, nacimiento.</p>
              <p>Genética: Ciencia que estudia la transmisión de genes.</p>
              <p>Genealogía: Estudio de los orígenes.</p>
              <p>Heterogéneo: diferente gen u origen.</p>
              <FormGroup className="mb-3">
        <div className="text-muted small mb-1">Homogéneo</div>
        <FormControl
            type="text"
            name="homogeneo"
            value={respuestas.homogeneo}
            onChange={handleChange}
        />
    </FormGroup>

          </FormGroup>
              </Form>
              <br />
              <Form className='border p-3'>
                 <FormGroup className="mb-3">
                                  
              {/* Raíz Haima = sangre */}
              <p><strong>Raíz: Haima = sangre</strong></p>
              <p>Hemorragia: Pérdida de sangre</p>
              <p>Hemática: Estudio de la sangre</p>
              <p>Hematocitos: Células sanguíneas</p>
              <p>Hemoglobina: Proteína de la sangre</p>
              </FormGroup>
              </Form>
              <br />
              <Form className='border p-3'>
                 <FormGroup className="mb-3">
              
              {/* Raíz: helios = sol */}
              <p><strong>Raíz: helios = sol</strong></p>
              <p>Heliofísica: Ciencia que estudia la constitución del sol</p>
              <p>Heliostato: Aparato para reflejar los rayos del sol en un punto específico.</p>

              {camposHelios.map(({ id, etiqueta }) => (
                <FormGroup key={id} className="mb-3">
                  <div className="text-muted small mb-1">{etiqueta}</div>
                  <FormControl
                    type="text"
                    name={id}
                    value={respuestas[id] ?? ''}
                    onChange={handleChange}
                  />
                </FormGroup>
              ))}
              </FormGroup>
              </Form>
              <br />
              <Form className='border p-3'>
                 <FormGroup className="mb-3">
              {/* Raíz: hemi = medio */}
              <p><strong>Raíz: hemi = medio</strong></p>
              <p>Ejemplos:</p>

              {camposHemi.map(({ id, etiqueta }) => (
                <FormGroup key={id} className="mb-3">
                  <div className="text-muted small mb-1">{etiqueta}</div>
                  <FormControl
                    type="text"
                    name={id}
                    value={respuestas[id] ?? ''}
                    onChange={handleChange}
                  />
                </FormGroup>
              ))}
              </FormGroup>
              </Form>
              <br />


            
          
            </Col>
            <Col md={6}>
            
            <Form className='border p-3'>
                 <FormGroup className="mb-3">
              {/* Contenido de la segunda columna */}
              

              <p>Hemistiquio: Parte de un verso cortada por una pausa</p>


              <p><strong>Raíz: Heteros = diferente</strong></p>

              {camposHeteros.map(({ id, etiqueta }) => (
                <FormGroup key={id} className="mb-3">
                  <div className="text-muted small mb-1">{etiqueta}</div>
                  <FormControl
                    type="text"
                    name={id}
                    value={respuestas[id] ?? ''}
                    onChange={handleChange}
                  />
                </FormGroup>
              ))}
               </FormGroup>
              </Form>
              <br />
              <Form className='border p-3'>
                 <FormGroup className="mb-3">

              {/* Raíz: Hypos: bajo, inferior */}
              <p><strong>Raíz: Hypos: bajo, inferior</strong></p>

              {camposHypos.map(({ id, etiqueta }) => (
                <FormGroup key={id} className="mb-3">
                  <div className="text-muted small mb-1">{etiqueta}</div>
                  <FormControl
                    type="text"
                    name={id}
                    value={respuestas[id] ?? ''}
                    onChange={handleChange}
                  />
                </FormGroup>
              ))}
              </FormGroup>
              </Form>
              <br />
              <Form className='border p-3'>
                 <FormGroup className="mb-3">

              {/* Raíz: hipos = cabello */}
              <p><strong>Raíz: hipos = cabello</strong></p>

              {camposHipos.map(({ id, etiqueta }) => (
                <FormGroup key={id} className="mb-3">
                  <div className="text-muted small mb-1">{etiqueta}</div>
                  <FormControl
                    type="text"
                    name={id}
                    value={respuestas[id] ?? ''}
                    onChange={handleChange}
                  />
                </FormGroup>
              ))}
              </FormGroup>
              </Form>
              <br />
              <Form className='border p-3'>
                 <FormGroup className="mb-3">

              {/* Raíz: homoios = igual */}
              <p><strong>Raíz: homoios = igual</strong></p>
              <p>Homeopatía: curación mediante sustancias semejantes a lo que se quiere curar</p>
              {camposHomoios.map(({ id, etiqueta }) => (
                <FormGroup key={id} className="mb-3">
                  <div className="text-muted small mb-1">{etiqueta}</div>
                  <FormControl
                    type="text"
                    name={id}
                    value={respuestas[id] ?? ''}
                    onChange={handleChange}
                  />
                </FormGroup>
              ))}
              </FormGroup>
              </Form>
              <br />
              <Form className='border p-3'>
                 <FormGroup className="mb-3">


              <p><strong>Raíz: hiper: sobre, mucho</strong></p>
              <p>Hiperestesia: Mucha sensibilidad</p>
              {camposHiper.map(({ id, etiqueta }) => (
                <FormGroup key={id} className="mb-3">
                  <div className="text-muted small mb-1">{etiqueta}</div>
                  <FormControl
                    type="text"
                    name={id}
                    value={respuestas[id] ?? ''}
                    onChange={handleChange}
                  />
                </FormGroup>
              ))}
              </FormGroup>
              </Form>
              <br />
            
          
        
        </Col>
        
        <button onClick={enviarResultados} className="btn btn-primary">Enviar Resultados</button>
        </Row>
      </div>
      );
};

export default Ejercicio10;

